var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('breadcrumb',{attrs:{"links":[{ text: '私隱政策' }]}}),_c('privacyPolicyContent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }